import React from "react";
import { FaGreaterThan, FaLessThan } from "react-icons/fa";

const Pagination = ({ currentPage, setCurrentPage, totalPages }) => {
  return (
    <div className="page-main-report">
      <div className="page-section">
        <div className="pagination">
          <button className="greyButton" disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
            <FaLessThan />
          </button>
          <span className="pagination-button">{currentPage}</span>
          <button className="greyButton" disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
            <FaGreaterThan />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;